import { BedayaAction } from '../../types/BedayaAction';
import { NexodusSettings } from '../../types/NexodusSettings';

import { DISCONNECT, GET_SETTINGS, PUT_SETTINGS } from '../actions/common_actions';
import { NEXODUS_CONNECT, NEXODUS_IMPORT_INVOICE, NEXODUS_WEBHOOK } from '../actions/nexodus_actions';

export interface INexodusState {
  settings: NexodusSettings | null;
  connectionStatus: any;
  isFetching: boolean;
  isFetchingDisconnect: boolean;
  isFetchingConnect: boolean;
  isFetchingWebhook: boolean;
  importInvoiceStatus: 'idle' | 'loading' | 'ok' | 'failed';
  connectError: any;
  error: any;
}

const initialState: INexodusState = {
  settings: null,
  connectionStatus: 'loading',
  isFetching: false,
  isFetchingDisconnect: false,
  isFetchingConnect: false,
  isFetchingWebhook: false,
  importInvoiceStatus: 'idle',
  connectError: null,
  error: '',
};

export default function reducer(state: INexodusState = initialState, action: BedayaAction): INexodusState {
  switch (action.type) {
    case GET_SETTINGS.REQUEST:
    case PUT_SETTINGS.REQUEST:
      if (['nexudus'].includes(action.data.system)) {
        return { ...state, isFetching: true };
      }
      return state;
    case DISCONNECT.REQUEST:
      if (['nexudus'].includes(action.data.system)) {
        return { ...state, isFetchingDisconnect: true };
      }
      return state;

    case GET_SETTINGS.SUCCESS:
    case PUT_SETTINGS.SUCCESS:
      if (['nexudus'].includes(action.data.system)) {
        return {
          ...state,
          settings: action.data.data,
          connectionStatus: action.data.data && action.data.data.connected ? 'ok' : 'nok',
          isFetching: false,
        };
      }
      return state;
    case DISCONNECT.SUCCESS:
      if (['nexudus'].includes(action.data.system)) {
        return {
          ...state,
          connectionStatus: 'nok',
          isFetching: false,
          isFetchingDisconnect: false,
        };
      }
      return state;

    case GET_SETTINGS.FAILURE:
    case PUT_SETTINGS.FAILURE:
      if (['nexudus'].includes(action.data.system)) {
        return { ...state, isFetching: false, connectionStatus: 'nok', error: action.data.error };
      }
      return state;
    case DISCONNECT.FAILURE:
      if (['nexudus'].includes(action.data.system)) {
        return { ...state, isFetchingDisconnect: false, error: action.data.error };
      }
      return state;

    case NEXODUS_CONNECT.REQUEST:
      return { ...state, isFetchingConnect: true, connectError: null };
    case NEXODUS_CONNECT.SUCCESS:
      return { ...state, isFetchingConnect: false };
    case NEXODUS_CONNECT.FAILURE:
      return { ...state, isFetchingConnect: false, connectError: action.error };

    case NEXODUS_WEBHOOK.REQUEST:
      return { ...state, isFetchingWebhook: true };
    case NEXODUS_WEBHOOK.SUCCESS:
      return { ...state, isFetchingWebhook: false };
    case NEXODUS_WEBHOOK.FAILURE:
      return { ...state, isFetchingWebhook: false, error: action.error };

    case NEXODUS_IMPORT_INVOICE.REQUEST:
      return { ...state, importInvoiceStatus: 'loading' };
    case NEXODUS_IMPORT_INVOICE.SUCCESS:
      return { ...state, importInvoiceStatus: 'ok' };
    case NEXODUS_IMPORT_INVOICE.FAILURE:
      return { ...state, importInvoiceStatus: 'failed' };

    default:
      return state;
  }
}
